import {dateFilterParams} from '../../views/components/ag-grid/filter-params/DateComparator';

export default [
  {
    headerName: 'DateOfSubmission',
    headerClass: 'header-text-wrap',
    field: 'DateOfSubmission',
    tooltipField: 'DateOfSubmission',
    tooltipComponentParams: { field: 'DateOfSubmission', isDate: true },
    minWidth: 100,
    filter: 'agDateColumnFilter',
    cellRenderer: 'CellRendererDate',
    filterParams: dateFilterParams,
  },
  {
    headerName: 'GeneratedServiceCode',
    headerClass: 'header-text-wrap',
    field: 'GeneratedServiceCode',
    tooltipField: 'GeneratedServiceCode',
    tooltipComponentParams: { field: 'GeneratedServiceCode' },
    filter: 'agTextColumnFilter',
    minWidth: 150,
  },
  {
    headerName: 'SubmissionStatus',
    headerClass: 'header-text-wrap',
    field: 'SubmissionStatus',
    tooltipField: 'SubmissionStatus',
    tooltipComponentParams: { field: 'SubmissionStatus' },
    filter: 'agSetColumnFilter',
    minWidth: 150,
  },
  {
    headerName: 'FirstName',
    headerClass: 'header-text-wrap',
    field: 'InsuredFirstName',
    tooltipField: 'InsuredFirstName',
    tooltipComponentParams: { field: 'InsuredFirstName' },
    filter: 'agTextColumnFilter',
    minWidth: 150,
  },
  {
    headerName: 'Surname',
    headerClass: 'header-text-wrap',
    field: 'InsuredSurname',
    tooltipField: 'InsuredSurname',
    tooltipComponentParams: { field: 'InsuredSurname' },
    filter: 'agTextColumnFilter',
    minWidth: 150,
  },
  {
    headerName: 'CompanyName',
    headerClass: 'header-text-wrap',
    field: 'InsuredCompanyName',
    tooltipField: 'InsuredCompanyName',
    tooltipComponentParams: { field: 'InsuredCompanyName' },
    filter: 'agTextColumnFilter',
    minWidth: 150,
  },
  {
    headerName: 'Producer',
    headerClass: 'header-text-wrap',
    field: 'ProducerCompanyName',
    tooltipField: 'ProducerCompanyName',
    tooltipComponentParams: { field: 'ProducerCompanyName' },
    filter: 'agTextColumnFilter',
    minWidth: 200,
  },
  {
    headerName: 'ProducerCode',
    headerClass: 'header-text-wrap',
    field: 'ProducerCompanyCode',
    tooltipField: 'ProducerCompanyCode',
    tooltipComponentParams: { field: 'ProducerCompanyCode' },
    filter: 'agTextColumnFilter',
    minWidth: 200,
  },
  {
    headerName: 'InsuredFiscalCode',
    headerClass: 'header-text-wrap',
    field: 'InsuredFiscalCode',
    tooltipField: 'InsuredFiscalCode',
    tooltipComponentParams: { field: 'InsuredFiscalCode' },
    filter: 'agTextColumnFilter',
    minWidth: 150,
  },
  {
    headerName: 'InsuredVATCode',
    headerClass: 'header-text-wrap',
    field: 'InsuredVATCode',
    tooltipField: 'InsuredVATCode',
    tooltipComponentParams: { field: 'InsuredVATCode' },
    filter: 'agTextColumnFilter',
    minWidth: 150,
  },
  {
    headerName: 'IsRemoteSignature',
    headerClass: 'header-text-wrap',
    field: 'IsRemoteSignature',
    tooltipField: 'IsRemoteSignature',
    tooltipComponentParams: { field: 'IsRemoteSignature' },
    filter: 'agSetColumnFilter',
    minWidth: 150,
  },
  {
    headerName: 'IsReferral',
    headerClass: 'header-text-wrap',
    field: 'IsReferral',
    tooltipField: 'IsReferral',
    tooltipComponentParams: { field: 'IsReferral' },
    filter: 'agSetColumnFilter',
    minWidth: 150,
  },
  {
    headerName: 'SubmitterNote',
    headerClass: 'header-text-wrap',
    field: 'SubmitterNote',
    tooltipField: 'SubmitterNote',
    tooltipComponentParams: { field: 'SubmitterNote' },
    filter: 'agTextColumnFilter',
    minWidth: 150,
  },
  {
    headerName: 'User',
    headerClass: 'header-text-wrap',
    field: 'SubmitterName',
    tooltipField: 'SubmitterName',
    tooltipComponentParams: { field: 'SubmitterName' },
    filter: 'agTextColumnFilter',
    minWidth: 200,
  },
];

